'use client';

import Link from 'next/link';
import { Button } from '@workspace/ui/common';
import { getButtonVariant } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { getLinkProps } from '@/app/lib';
import type { IHeaderButton } from '../interfaces';

interface PrimaryButtonProps {
  primaryButton?: IHeaderButton | null;
}

export const PrimaryButton = ({ primaryButton }: PrimaryButtonProps) => {
  if (!primaryButton || !primaryButton.link) return null;

  const linkProps = getLinkProps(primaryButton.link) as {
    href?: string;
    target?: string;
    rel?: string;
  };

  if (!linkProps?.href) return null;

  const isAnchorLink = primaryButton.link?.type === 'anchor' && !!primaryButton.link?.anchor;
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchorLink) return;
    e.preventDefault();
    const raw = (primaryButton.link?.anchor as string) || '';
    const id = raw.startsWith('#') ? raw.slice(1) : raw;
    const el = document.getElementById(id);
    // Always update hash
    try {
      window.history.replaceState(null, '', `#${id}`);
    } catch {}
    // Smooth scroll only if element exists
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Link
      href={linkProps.href}
      target={linkProps.target}
      rel={linkProps.rel}
      onClick={isAnchorLink ? handleAnchorClick : undefined}
    >
      <Button
        variant={getButtonVariant(primaryButton.style)}
        iconName="MapPin"
        iconPosition="left"
        iconColor="white"
        className="cursor-pointer pt-3 pb-3 font-semibold gap-[8px] !justify-between !leading-[20px]"
      >
        {stripInvisibles(primaryButton.label || '').trim()}
      </Button>
    </Link>
  );
};
